export default {
  name: "HeroSection",

  data() {
    return ({
      hero_cards: [
        {
          key: "utilities",
          label: "Utilities",
          icon: "custom",
          logo: "https://empirewebvideos.s3.us-east-1.amazonaws.com/Probabase_bolide/short_bolide_logo.png",
        },
        {
          key: "energy",
          label: "Energy",
          icon: "bi bi-lightning-charge-fill",
        },
        {
          key: "security",
          label: "Security",
          icon: "bi bi-shield-lock-fill",
        },
        {
          key: "connectivity",
          label: "Connectivity",
          icon: "bi bi-wifi",
        },
      ],
      hero_data:{
        headline: "BRIDGING THE DIVIDE",
        sub_headline: "Smart integrated utilities dashboard.",
        btn_text: "Get Started",
      }
    });
  },

};
